import { gql } from "@apollo/client";

export const fetchOrganisationQuery = gql`
  query FetchOrganisation($businessId: String!) {
    FetchOrganisation(businessId: $businessId) {
      name
      businessid
      status
    }
  }
`;

export type fetchOrganisationVariables = {
  businessId: string;
};

export type fetchOrganisationQueryResult = {
  FetchOrganisation: crmOrganisation;
};

export type crmOrganisation = {
  name: string;
  businessid: string;
  status?: "not_found" | "ok";
};

export default fetchOrganisationQuery;
